import AvatarM from "@common/components/avatar/AvatarM"
import * as Clipboard from "expo-clipboard"
import React from "react"
import { View } from "react-native"
import { IconButton, TouchableRipple } from "react-native-paper"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { theme } from "../../theme/theme"
import { IconImageM } from "../icons/IconsM"
import TextM from "../text/TextM"

export function ListItemM(props) {
    // ** Component props
    const {
        isFirst,
        isLast,
        option,
        selected,
        itemHeight,
        noBorder,
        disabled,
        withClipBoard = false,
        checkColor = theme.colors.primary,
        selectedBackgroundColor = theme.colors.primaryLighter,
    } = props

    return (
        <TouchableRipple
            style={{
                borderTopStartRadius: isFirst ? 15 : 0,
                borderTopEndRadius: isFirst ? 15 : 0,
                borderBottomStartRadius: isLast ? 15 : 0,
                borderBottomEndRadius: isLast ? 15 : 0,
                opacity: (option?.disabled || disabled) ? 0.5 : 1,
                backgroundColor: selected ? selectedBackgroundColor : null,
                width: "100%",
            }}
            onPress={props.onPress}
            onLongPress={props.onLongPress}
            disabled={disabled || option?.disabled}
            underlayColor={theme.colors.lightMore}
        >
            <View
                style={{
                    ...props.style,
                    height: itemHeight,
                    borderColor: theme.colors.lightMore,
                    borderBottomWidth: !noBorder && !isLast ? 1 : 0,
                    flexDirection: "row",
                    alignItems: "center",
                    paddingLeft: 10,
                    paddingRight: 20,
                    width: "100%",
                }}
            >
                {option?.leftComponent ? option?.leftComponent : null}

                {!!option?.icon && (
                    <IconImageM
                        uri={option?.icon}
                        style={{
                            marginRight: 10,
                            marginBottom: itemHeight > 70 ? itemHeight / 3 : 0,
                            tintColor: option?.tintColor ?? null,
                        }}
                        width={40}
                    />
                )}

                {option?.source && (
                    <IconImageM
                        source={option?.source}
                        style={{
                            marginRight: 10,
                            marginBottom: 0,
                            tintColor: option?.tintColor ?? null,
                        }}
                        width={40}
                    />
                )}
                {option?.avatar && (
                    <AvatarM
                        size={40}
                        user={option?.avatar}
                        style={{
                            marginRight: 10,
                            marginBottom: itemHeight > 70 ? itemHeight / 3 : 0,
                        }}
                    />
                )}

                {option?.iconName && (
                    <View
                        style={{
                            width: 40,
                            height: 40,
                            borderRadius: 20,
                            backgroundColor: option?.iconBackgroundColor ?? theme.colors.primaryLighter,
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: 10,
                        }}
                    >
                        <FontAwesome5
                            name={option?.iconName}
                            size={option?.iconSize ?? 18}
                            color={option?.iconColor ?? theme.colors.primary}
                            solid={option?.iconSolid !== false}
                        />
                    </View>
                )}

                <View
                    style={{
                        flex: 1,
                        paddingVertical: 2,
                    }}
                >
                    <View
                        style={{
                            flexDirection: "column",
                            alignItems: "flex-start",
                        }}
                    >
                        <TextM
                            fontWeight="Bold"
                            color={theme.colors.grey}
                            wrap
                            fontSize={16}
                        >
                            {option?.label}
                        </TextM>
                        {option?.extraLabel && (
                            <TextM
                                fontWeight="SemiBold"
                                color={theme.colors.grey}
                                style={{
                                    fontStyle: "italic",
                                }}
                                wrap
                                fontSize={12}
                            >
                                {option?.extraLabel}
                            </TextM>
                        )}
                    </View>
                    {option?.description && (
                        <TextM
                            fontWeight="Regular"
                            color={theme.colors.grey}
                            style={{
                                marginRight: 10,
                            }}
                            wrap
                            fontSize={12}
                        >
                            {option?.description}
                        </TextM>
                    )}
                </View>
                {selected && (
                    <FontAwesome5
                        name={"check"}
                        style={{ position: "absolute", right: 12 }}
                        color={checkColor}
                        size={20}
                    />
                )}
                {withClipBoard && (
                    <IconButton
                        icon="copy"
                        iconColor={theme.colors.greyAlt}
                        containerColor={theme.colors.transparent}
                        size={24}
                        style={{ position: "absolute", top: 0, right: 0 }}
                        onPress={() => {
                            Clipboard.setStringAsync(option?.label).then()
                        }}
                    />
                )}
            </View>
        </TouchableRipple>
    )
}
